export const getMixpanelEnrichment = () => {
    if (typeof window !== 'undefined' && window.mixpanelEnrichment) {
        return window.mixpanelEnrichment;
    } else {
        return {};
    }
};
